// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 2143 ? "app" : chunkId) + "." + {"2143":"eae88765","4984":"329257be","5980":"448c81af"}[chunkId] + ".chunk.css";
};